import {httpClient, httpsFunctions} from "./Api";
import md5 from "md5";


export const authRequest = (path, params, cb) => ({memberId, adminId, password}) => {
    const md5password = md5(password);
    const urlParams = new URLSearchParams(adminId ? {
        ...params,
        memberId,
        adminId,
        token: md5password
    } : {
        ...params,
        memberId,
        token: md5password
    })
    const url = `${path}?${urlParams.toString()}`;

    return httpsFunctions.get(url)
        .then(({data}) => {

            if (cb) cb({data: data, status: true});
        })
        .catch(function (error) {

            cb({data: error, status: false});
        });
}

export const getUserBookings = ({memberId, adminId, password}, cb) => {
    return authRequest('/getUserBookings', {}, cb)({memberId, adminId, password});
}

export const switchWeekend = ({
                                  adminId,
                                  courseId,
                              }, cb) => {
    return httpsFunctions.get(`/switchWeekend?adminId=${adminId}&courseId=${courseId}&token=asdfasdfj5234523_gdsfgsdfg____323__34534gggsdfvvvbbb`)
        .then(({data}) => {
            if (cb) cb({data: data, status: true});
        })
        .catch(function (error) {
            cb({data: error, status: false});
        });
}

export const getMembers = callbackFun => {
    httpClient.defaults.headers.common["Authorization"] = "Bearer " + "ey2sakxhakskxnalwoeu297dhs9dsxnx9s0";

    httpClient
        .get(`/members/`)
        .then(({data}) => {
            if (callbackFun) callbackFun({data: data, status: true});
        })
        .catch(function (error) {
            callbackFun({data: error, status: false});
        });
};

export const updateCourse = (callbackFun, course) => {
    httpClient.defaults.headers.common["Authorization"] = "Bearer " + "ey2sakxhakskxnalwoeu297dhs9dsxnx9s0";

    httpClient
        .post(`/members/WeekendOpen`, {course: course, docName: course.docName})
        .then(({data}) => {
            if (callbackFun) callbackFun({data: data, status: true});
        })
        .catch(function (error) {
            callbackFun({data: error, status: false});
        });
};

export const checkPreAuthUser = (model, callbackFun) => {
    httpClient
        .post(`/booking/updateSlot`, model)
        .then(({data}) => {
            if (callbackFun) callbackFun({data: data, status: true});
        })
        .catch(function (error) {
            callbackFun({data: error, status: false});
        });
};



